const EditCaretPositioning = {};
export default EditCaretPositioning;
if (window.getSelection && document.createRange) {
  EditCaretPositioning.saveSelection = function(containerEl) {
    var range = window.getSelection().getRangeAt(0);
    var preSelectionRange = range.cloneRange();
    preSelectionRange.selectNodeContents(containerEl);
    preSelectionRange.setEnd(range.startContainer, range.startOffset);
    var start = preSelectionRange.toString().length;
    return {
      start,
      end: start + range.toString().length
    };
  };
  EditCaretPositioning.restoreSelection = function(containerEl, savedSel) {
    var charIndex = 0, range = document.createRange();
    range.setStart(containerEl, 0);
    range.collapse(true);
    var nodeStack = [containerEl], node, foundStart = false, stop = false;
    while (!stop && (node = nodeStack.pop())) {
      if (node.nodeType === 3) {
        var nextCharIndex = charIndex + node.length;
        if (!foundStart && savedSel.start >= charIndex && savedSel.start <= nextCharIndex) {
          range.setStart(node, savedSel.start - charIndex);
          foundStart = true;
        }
        if (foundStart && savedSel.end >= charIndex && savedSel.end <= nextCharIndex) {
          range.setEnd(node, savedSel.end - charIndex);
          stop = true;
        }
        charIndex = nextCharIndex;
      } else {
        var i = node.childNodes.length;
        while (i--) {
          nodeStack.push(node.childNodes[i]);
        }
      }
    }
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  };
} else if (document.selection && document.body.createTextRange) {
  EditCaretPositioning.saveSelection = function(containerEl) {
    var selectedTextRange = document.selection.createRange();
    var preSelectionTextRange = document.body.createTextRange();
    preSelectionTextRange.moveToElementText(containerEl);
    preSelectionTextRange.setEndPoint("EndToStart", selectedTextRange);
    var start = preSelectionTextRange.text.length;
    return {
      start,
      end: start + selectedTextRange.text.length
    };
  };
  EditCaretPositioning.restoreSelection = function(containerEl, savedSel) {
    var textRange = document.body.createTextRange();
    textRange.moveToElementText(containerEl);
    textRange.collapse(true);
    textRange.moveEnd("character", savedSel.end);
    textRange.moveStart("character", savedSel.start);
    textRange.select();
  };
}
const noop = () => null;
export function selectionSaveCaretPosition(container) {
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) {
    return noop;
  }
  const range = selection.getRangeAt(0);
  const clone = range.cloneRange();
  clone.selectNodeContents(container);
  clone.setStart(container, 0);
  clone.setEnd(range.startContainer, range.startOffset);
  const startIndex = clone.toString().length;
  clone.selectNodeContents(container);
  clone.setStart(container, 0);
  clone.setEnd(range.endContainer, range.endOffset);
  const endIndex = clone.toString().length;
  return function restoreCaretPosition() {
    const start = getTextNodeAtPosition(container, startIndex);
    const end = getTextNodeAtPosition(container, endIndex);
    const newRange = new Range();
    newRange.setStart(start.node, start.position);
    newRange.setEnd(end.node, end.position);
    selection.removeAllRanges();
    selection.addRange(newRange);
    container.focus();
  };
}
function getTextNodeAtPosition(rootEl, index) {
  const treeWalker = document.createTreeWalker(
    rootEl,
    NodeFilter.SHOW_TEXT,
    function next(elem) {
      if (index > elem.textContent.length) {
        index -= elem.textContent.length;
        return NodeFilter.FILTER_REJECT;
      }
      return NodeFilter.FILTER_ACCEPT;
    }
  );
  const node = treeWalker.nextNode();
  return {
    node: node ? node : rootEl,
    position: node ? index : 0
  };
}
